import { Box, Stack } from '@mui/material'

import { ModalFooterButton } from '@/components/Modal'

import { useController } from '../hooks/useController'
import { useControllerActions } from '../hooks/useControllerActions'
import { useTexts } from '../useTexts'

export function Footer() {
  const texts = useTexts()
  const { close } = useController()
  const { handleStart, isLoading } = useControllerActions()

  return (
    <Box
      component="footer"
      sx={{
        px: 3,
        py: 2,
        borderTop: t => `1px solid ${t.vars.palette.divider}`,
      }}
    >
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <ModalFooterButton testid="route-optimization__cancel" onClick={close} disabled={isLoading}>
          {texts.cancel}
        </ModalFooterButton>
        <ModalFooterButton
          testid="route-optimization__start"
          variant="contained"
          onClick={handleStart}
          loading={isLoading}
        >
          {texts.startOptimization}
        </ModalFooterButton>
      </Stack>
    </Box>
  )
}
